import { Middleware, Context } from '@nuxt/types'

const setMarketplace: Middleware = ({ route, store }: Context): void => {
  const { country } = route.params
  const marketplace = country ? 'global' : 'local'
  store.dispatch('context/setMarketplace', marketplace)
}
export default setMarketplace
